import React from "react"

import { Challenge } from "./Challenge"
import { Element } from "legacy/components/shared/base"
import { PrismicPageDataBodyChallengeCarouselItem } from "types/__generated__/gatsby-graphql"
import { Maybe } from "types/Maybe"

export type SlideProps = {
  challenges: Maybe<PrismicPageDataBodyChallengeCarouselItem>
  title: Maybe<PrismicPageDataBodyChallengeCarouselItem<"carousel_title">>
  smallImages?: boolean
}

export const Slide: React.FC<SlideProps> = ({
  challenges,
  title,
  smallImages,
}): React.ReactElement | null => {
  return (
    <Element mt={["md", "0"]}>
      {title && (
        <Element
          color="offBlack"
          fontFamily="prospectus"
          fontSize="24"
          fontWeight="700"
          lineHeight="30px"
          mb={["md", "lg"]}
          textAlign="center"
        >
          {title}
        </Element>
      )}
      <Element
        display="grid"
        gridGap="sm"
        gridTemplateColumns={
          challenges.length === 1
            ? "1fr"
            : ["1fr 1fr", "1fr 1fr", "1fr 1fr 1fr"]
        }
        justifyItems="center"
      >
        {challenges.map((challenge, index) => {
          const { challenge_icon, challenge_name, challenge_value } = challenge

          return (
            <Challenge
              icon={challenge_icon}
              key={index}
              name={challenge_name}
              smallImages={smallImages}
              value={challenge_value}
            />
          )
        })}
      </Element>
    </Element>
  )
}
